export const Alphabetic = (event) => {
  var x = event.charCode || event.keyCode;
  if ((x > 96 && x < 123) || (x > 64 && x < 91) || x === 32) {
    return true;
  } else {
    event.preventDefault();
    return false;
  }
};

export const Numeric = (event) => {
  var x = event.charCode || event.keyCode;
  if (x > 47 && x < 58) {
    return true;
  } else {
    event.preventDefault();
    return false;
  }
};
